/**
 * Check if an enum has a given key.
 *
 * @param enumerable - An enum.
 * @param value - A key.
 */
export const enumHasKey = <T extends Record<string, string | number>>(
  value: string,
  enumerable: T
): value is string & keyof T => {
  const keys = Object.keys(enumerable);

  if (keys.includes("0")) {
    const validKeys = keys.slice(keys.length / 2);

    return validKeys.includes(value.toString());
  }

  return keys.includes(value.toString());
};

/**
 * Check if an enum has a given value.
 *
 * @param enumerable - An enum.
 * @param value - A value.
 */
export const enumHasValue = <T extends Record<string, string | number>>(
  value: unknown,
  enumerable: T
): value is T[keyof T] => {
  for (const [entryKey, entryValue] of Object.entries(enumerable)) {
    if (Number.isNaN(parseInt(entryKey, 10)) && entryValue === value) {
      return true;
    }
  }

  return false;
};
